// 프로덕션 환경에서 콘솔 로그를 비활성화하는 로거

const isDevelopment = process.env.NODE_ENV === 'development';
const enableLogs = process.env.REACT_APP_ENABLE_LOGS === 'true';

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment || enableLogs) {
      console.log(...args);
    }
  },
  info: (...args: any[]) => {
    if (isDevelopment || enableLogs) {
      console.info(...args);
    }
  },
  warn: (...args: any[]) => {
    if (isDevelopment || enableLogs) {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    // 에러는 항상 표시
    console.error(...args);
  },
  debug: (...args: any[]) => {
    if (isDevelopment || enableLogs) {
      console.debug(...args);
    }
  },
  table: (data: any) => {
    if (isDevelopment || enableLogs) {
      console.table(data);
    }
  },
  time: (label: string) => {
    if (isDevelopment || enableLogs) {
      console.time(label);
    }
  },
  timeEnd: (label: string) => {
    if (isDevelopment || enableLogs) {
      console.timeEnd(label);
    }
  }
};

// 전역 console 객체 오버라이드 (프로덕션 환경에서)
if (!isDevelopment && !enableLogs) {
  window.console.log = () => {};
  window.console.info = () => {};
  window.console.warn = () => {};
  window.console.debug = () => {};
  window.console.table = () => {};
  window.console.time = () => {};
  window.console.timeEnd = () => {};
}